import { generateSaintLocoHeaders, generateAgwHeaders } from '@/helpers/utils';
import { get, post } from '@/api';
const AGW_URL = process.env.VUE_APP_AGW_URL;

// RECO BUTLER

// Get Promo Recommendations from AGW - Reco Butler
export async function getPromoRecommendations(params) {
  const headers = await generateAgwHeaders(params);
  return post(`${AGW_URL}/alfred/v2/page/dealspage`, headers);

}

// SAINT LOCO via AGW

// Get Promo Detail from Saint Loco
export async function getPromoDetail(id) {
  const headers = await generateSaintLocoHeaders();
  return get(`${AGW_URL}/v2/deals/${id}`, headers);
};
// Get Promo Stores By Merchant Id from Saint Loco
export async function getPromoMerchants(id) {
  const headers = await generateSaintLocoHeaders();
  return get(`${AGW_URL}/v2/deals/${id}/merchants`, headers);
};
// Get Promo Stores By Merchant Id from Saint Loco
export async function getPromoStoresByMerchant(payload) {
  const headers = await generateSaintLocoHeaders();
  return get(`${AGW_URL}/v2/deals/${payload.promoId}/merchants/${payload.merchantId}/stores`, headers, payload);
};
